import React, { Component } from "react";
import { Link } from "react-router-dom";

import { FriendsType } from "../helper/type_helper";

class UserImage extends Component {
  state = {};
  render() {
    var style = {};
    if (this.props.bottomImage) {
      style = {
        display: "block",
        position: "absolute",
        bottom: "-8px",
        width: "100%"
      };
    }

    var colorClass = "user_img_div color_not_friends";
    if (this.props.user.friendship_type && this.props.user.friend) {
      switch (this.props.user.friendship_type) {
        case FriendsType.close_friends: {
          colorClass = "user_img_div color_closed_friends";
          break;
        }
        case FriendsType.friends: {
          colorClass = "user_img_div color_friends";
          break;
        }
        case FriendsType.acquaintance: {
          colorClass = "user_img_div color_acquaintance";
          break;
        }
        default: {
        }
      }
    }

    if (this.props.user.me) {
      colorClass = "user_img_div";
    }

    if (this.props.link === false) {
      return (
        <div style={style}>
          <div className="user_img">
            <div className={colorClass} />
            <img
              className="no_border"
              src={this.props.user.image_url_medium}
              alt="user"
            />
          </div>
          {this.renderName()}
        </div>
      );
    }
    return (
      <Link style={style} to={"/users/" + this.props.user.username}>
        <div className="user_img">
          <div className={colorClass} />
          <img
            className="no_border"
            src={this.props.user.image_url_medium}
            alt="user"
          />
        </div>
        {this.renderName()}
      </Link>
    );
  }
  renderName() {
    if (this.props.show_name) {
      return (
        <div className="user_img_username yaystack_color">
          {this.props.user.username}
        </div>
      );
    }
    return <div />;
  }
}

export default UserImage;



// WEBPACK FOOTER //
// ./src/components/user_image.jsx